<template>
<div>
    <md-dialog-content>
        <p>Create Your Starting Layers</p>
        <md-list>
            <layer-lite v-for="layer in project.layers"
                :key="layer.id"
                :layer="layer" 
                @deleteLayer="deleteLayer">
            </layer-lite>
        </md-list>
        <layer-new :project="project" @addLayer="addLayer" />
    </md-dialog-content>
</div>
</template>

<script>
import LayersLayerLite from '@/components/layers/layer-lite';
import LayersLayerNew from '@/components/layers/layer-new';

const Layers = {
    name: 'layers',
    props: ['project'],
    methods: {
        addLayer(layer) {
            layer.id = Math.random() * 100000;
            this.project.layers.unshift(layer);
        },
        deleteLayer(layer) {
            const index = this.project.layers.findIndex((l) => {
                return l.title === layer.title;
            });
            this.project.layers.splice(index, 1);
        }
    },
    components: {
        'layer-lite': LayersLayerLite,
        'layer-new': LayersLayerNew
    }
};
export default Layers;
</script>

<style>
</style>


// WEBPACK FOOTER //
// layers.vue?2ae0963e